import { render, staticRenderFns } from "./invitesLog.vue?vue&type=template&id=d6b796e2"
import script from "./invitesLog.vue?vue&type=script&lang=js"
export * from "./invitesLog.vue?vue&type=script&lang=js"
import style0 from "./invitesLog.vue?vue&type=style&index=0&id=d6b796e2&prod&tyle=text%2Fcss&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports